{
  "action_add": {
    "title": "Projekt erstellen",
    "error_not_found": "Es ist ein Fehler aufgetreten",
    "error_duplicate_name": "Name wurde bereits vergeben"
  }
}
